import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      backgroundColor: '#42A5F5',
      borderRadius: 5,
      color: '#fff',
      fontSize: 14,
      fontWeight: 'bold',
      height: 50,
      letterSpacing: 1.3,
      margin: '25px 0',
      textTransform: 'capitalize',
      width: 300,
      '&:hover': {
        backgroundColor: '#42A5F5',
      },
    },
    contentContainer: {
      alignItems: 'center',
      backgroundColor: 'white',
      borderRadius: '10px 10px 0 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      maxHeight: 440,
      marginTop: -10,
      minHeight: 200,
    },
    dialogContainer: {
      margin: 0,
      width: '100%',
    },
    modal: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      outline: 0,
    },
    paper: {
      bottom: 0,
      left: 'auto',
      position: 'fixed',
      right: 'auto',
      top: 'auto',
    },

    textContainer: {
      marginLeft: 25,
      marginRight: 25,
      marginTop: 10,
      maxHeight: 260,
      minHeight: 10,
      overflowY: 'scroll',
    },
    toriiBotDialog: {
      backgroundColor: '#FFFF',
      maxHeight: 260,
      minhHight: 100,
      paddingHorizontal: 20,
      paddingTop: 20,
      zIndex: 9,
      overflowY: 'scroll',
    },
  }),
);

export default styles;
